import React, {
  useEffect,
  Suspense
} from "react";
import { Route, Routes } from "react-router-dom";
import AuthGuard from "./Route/AuthGuard";
import PrivateRoute from "./Route/PrivateRoute";
import Auth from "./components/Auth";
import Layout from "./components/layout/Layout";
import AntSidebar from "./components/sidebar/AntSidebar";
import { setupFirebaseMessaging } from './firebaseMessagingHandler';
import { fetchAllNotifications } from "./app/slice/chatSlice";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import Reset from "./pages/auth/Reset";
import NoMatch from "./components/NoMatch";
import ResetComponent from "./components/forms/ResetForm";
import CompanyDashboard from "./pages/dashboard/companyDashboard";
import UserDetail from "./pages/user/UserDetail";
import CompanyDetail from "./pages/company/CompanyDetail";
import FreshRequest from "./pages/contracts/FreshRequest";
import InitiateRequest from "./pages/contracts/CreateRequest";
import SettingsPage from "./pages/Settings";
import CompanyAnalytics from "./pages/company/CompanyAnalytics";
import ContractDetailComp from "./pages/contracts/ContractDetail";
import Index from "./pages/contracts/third_party/Index";
import ForgotPassword from "./pages/auth/ForgotPassword";
import MasterTemplate from "./pages/masterTemplate/MasterTemplate";
import ClauseTemplate from "./pages/clauseTemplate/clauseTemplate";
import TicketDetails from './pages/supportSystem/TicketDetails';
import CreateTicket from './pages/supportSystem/addTicket/addTicket';
import SupportSystem from './pages/supportSystem'
import ScheduleMeeting from './pages/supportSystem/ScheduleMeeting'
import ErrorPage from './components/ErrorPage';
import MyComponent from './syncFusion/SyncDummy';
import { useDispatch, useSelector } from "react-redux";
import Listing from "./pages/Esign/listing";
import AddEsign from "./pages/Esign/AddEsign";
import EsignListitemDetails from "./pages/Esign/EsignListitemDetails";
import { startIdleListener, stopIdleListener } from "./utils/IdleLogoutManager";
import DemoScheduler from "./pages/auth/DemoRequest";
import CCompanyDashboard from "./pages/professional/company";
import ProfessionalRoute from "./Route/ProfessionalRoute";
import CompareFileSFDT from "./syncFusion/CompareFile";
import { ConfigProvider } from "antd";
import { useTheme } from "./utils/themeToggle/theme";
import ProfessionalUsers from "./pages/professional/ProfessionalUsers";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ApproveAgreementPage from "./pages/ApproveAgreementPage/ApproveAgreement";

function App(props) {
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.auth.accessToken);
  const user_id = useSelector((store) => store.auth.userInfo.user_id);
  const { antTheme } = useTheme();
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const companyId = Number(localStorage.getItem('companyId')) || comp_id;
  const handelContextmenu = (event) => {
    event.preventDefault();
  }
  useEffect(() => {
    if (accessToken) {
      return () => {
        window.removeEventListener("contextmenu", handelContextmenu);
      };
    }
  }, []);

  useEffect(() => {
    setupFirebaseMessaging();
    console.log('Firebase Messaging setup calledddddddddddddddddddddddddddddddddddddddddddddddddddddddd');
    const handler = (event) => {
      if (event.data?.type === 'FCM_NOTIFICATION') {
        console.log('🔔 Message from SW:', event.data.payload.data.agreementId);
        const id = event?.data?.payload?.data?.agreementId;
        if (id) {
          console.log(user_id)
          dispatch(fetchAllNotifications({ user_id, company_id: companyId }));
        }
      };
    }
    navigator?.serviceWorker?.addEventListener('message', handler);
    return () => {
      navigator?.serviceWorker?.removeEventListener('message', handler);
    };
  }, []);


  useEffect(() => {
    startIdleListener();

    return () => {
      stopIdleListener();
    };
  }, []);

  return (
    <ConfigProvider theme={antTheme}>
      <Suspense
        fallback={
          <div className="flex items-center justify-center overflow-hidden">
            <div className="flex flex-col items-center space-y-4">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
              <p className="text-gray-600 text-lg font-medium">Preparing something awesome for you...</p>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<AuthGuard><Layout /></AuthGuard>}>
            <Route path="auth" element={<Auth />}>
              <Route index path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              <Route path="reset_password" element={<Reset />} />
              <Route path="forgot-password" element={<ForgotPassword />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="demo-request" element={<DemoScheduler />} />
            </Route>

            <Route path="admin" element={<PrivateRoute><AntSidebar /></PrivateRoute>}>
              <Route path="dashboard" element={<CompanyDashboard />} />
              <Route path="analytics" element={<CompanyAnalytics />} />
              <Route path="template" element={<MasterTemplate />} />
              <Route path="clause" element={<ClauseTemplate />} />
              <Route path="reset_password" element={<ResetComponent />} />
              <Route path="contracts/create_request" element={<InitiateRequest />} />
              <Route path="contracts/agreement_type/:status" element={<FreshRequest />} />
              <Route path="contracts/agreement_type/:status/:pk" element={<ContractDetailComp />} />
              <Route path="contracts" element={<FreshRequest />} />
              <Route path="contracts/:pk" element={<ContractDetailComp />} />
              <Route path="contracts/user-filtered" element={<FreshRequest />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="user/:pk" element={<UserDetail />} />
              <Route path="company/:pk" element={<CompanyDetail />} />
              <Route path="esign" element={<Listing />} />
              <Route path="esign/details/:id" element={<EsignListitemDetails />} />
              <Route path="esign/create_esign" element={<AddEsign />} />
              <Route path="support" element={<SupportSystem />} />
              <Route path="support/create_ticket" element={<CreateTicket />} />
              <Route path="support/schedule_meeting" element={<ScheduleMeeting />} />
              <Route path="support/details/:id" element={<TicketDetails />} />
              <Route path="setting/ticket/details/:id" element={<TicketDetails />} />
            </Route>
            <Route path="/admin/company" element={<ProfessionalRoute>
              <AntSidebar />
            </ProfessionalRoute>}>
              <Route path="professional" element={<CCompanyDashboard />} />
              <Route path="professional/users" element={< ProfessionalUsers />} />
              <Route path="professional/user/:pk" element={<UserDetail />} />
              <Route path=":companyId/dashboard" element={<CompanyDashboard />} />
              <Route path=":companyId/analytics" element={<CompanyAnalytics />} />
              <Route path=":companyId/template" element={<MasterTemplate />} />
              <Route path=":companyId/clause" element={<ClauseTemplate />} />
              <Route path=":companyId/contracts" element={<FreshRequest />} />
              <Route path=":companyId/contracts/create_request" element={<InitiateRequest />} />
              <Route path=":companyId/contracts/:pk" element={<ContractDetailComp />} />
              <Route path=":companyId/settings" element={<SettingsPage />} />
              <Route path=":companyId/user/:pk" element={<UserDetail />} />
              <Route path=":companyId/esign" element={<Listing />} />
              <Route path=":companyId/esign/details/:id" element={<EsignListitemDetails />} />
              <Route path=":companyId/esign/create_esign" element={<AddEsign />} />
            </Route>

            <Route path="*" element={<NoMatch />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="edit-document/:pk" element={<MyComponent />} />
            <Route path="contracts/riceived_agreement/" element={<Index />} />
            <Route path="/version-diff-viewer/" element={<CompareFileSFDT />} />
            <Route path="/approve-agreement/:token" element={<ApproveAgreementPage />} />

          </Route>
        </Routes>

      </Suspense>
    </ConfigProvider>
  );
}
export default App;
